"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var BaseController_1 = require("../../../../../shared/controllers/BaseController");
var webAApi_1 = require("../../../../api/webAApi");
var UIUtils_1 = require("../../../../../shared/modules/UIUtils");
var moment = require("moment");
var FinanceWithdrawRequestsListCtl = /** @class */ (function (_super) {
    __extends(FinanceWithdrawRequestsListCtl, _super);
    function FinanceWithdrawRequestsListCtl(errDialog) {
        var _this = _super.call(this, true) || this;
        _this.dk_brand_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.brand_title; });
        _this.dk_player_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_id; });
        _this.dk_player_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_login; });
        _this.dk_player_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_email; });
        _this.dk_player_is_locked = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_is_locked; });
        _this.dk_partner_id = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_id; });
        _this.dk_partner_login = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_login; });
        _this.dk_partner_email = UIUtils_1.UIUtils.IProp2Str(function (o) { o.partner_email; });
        _this.dk_withdraw_basis_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_basis_title; });
        _this.dk_withdraw_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_currency_title; });
        _this.dk_amount_in_withdraw_currency_without_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_withdraw_currency_without_comission; });
        _this.dk_amount_in_withdraw_currency_wit_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_withdraw_currency_with_comission; });
        _this.dk_player_currency_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_currency_title; });
        _this.dk_amount_in_player_currency_without_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_player_currency_without_comission; });
        _this.dk_amount_in_player_currency_with_comission = UIUtils_1.UIUtils.IProp2Str(function (o) { o.amount_in_player_currency_with_comission; });
        _this.dk_exchange_rate_withdraw_to_player = UIUtils_1.UIUtils.IProp2Str(function (o) { o.exchange_rate_withdraw_to_player; });
        _this.dk_player_withdraw_nocomission_limit_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_withdraw_nocomission_limit_before; });
        _this.dk_player_balance_before = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_before; });
        _this.dk_player_balance_after = UIUtils_1.UIUtils.IProp2Str(function (o) { o.player_balance_after; });
        _this.dk_withdraw_state_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_state_code; });
        _this.dk_withdraw_state_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_state_title; });
        _this.dk_withdraw_type_code = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_type_code; });
        _this.dk_withdraw_type_title = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_type_title; });
        _this.dk_description = UIUtils_1.UIUtils.IProp2Str(function (o) { o.description; });
        _this.dk_date_added = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_added; });
        _this.dk_date_changed = UIUtils_1.UIUtils.IProp2Str(function (o) { o.date_changed; });
        _this.dk_is_pending = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_pending; });
        _this.dk_withdraw_data = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_data; });
        _this.dk_withdraw_req = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_req; });
        _this.dk_withdraw_resp = UIUtils_1.UIUtils.IProp2Str(function (o) { o.withdraw_resp; });
        _this.dk_money_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.money_balance; });
        _this.dk_points_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.points_balance; });
        _this.dk_bonus_balance = UIUtils_1.UIUtils.IProp2Str(function (o) { o.bonus_balance; });
        _this.dk_is_active_bonus = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_active_bonus; });
        _this.dk_is_suspicious = UIUtils_1.UIUtils.IProp2Str(function (o) { o.is_suspicious; });
        _this._errDialog = errDialog;
        return _this;
    }
    FinanceWithdrawRequestsListCtl.prototype.ResetData = function () {
        this.DATA = {
            total: 0,
            data: []
        };
    };
    FinanceWithdrawRequestsListCtl.prototype.getById = function (id) {
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === id) {
                return this.DATA.data[i];
            }
        }
        return null;
    };
    FinanceWithdrawRequestsListCtl.prototype.LoadRangeDataByBrandsList = function (data, onDone) {
        var _this = this;
        webAApi_1.ListNewWithdrawsByBrandIdGet.exec({
            all_brands: data.allBrands,
            brand_id_list: data.brands,
            offset: data.Offset,
            limit: data.Limit,
        }, function (resp) {
            _this.DATA.data = [];
            _this.DATA.total = resp.total_count;
            for (var i = 0; i < resp.list.length; i++) {
                _this.DATA.data.push({
                    key: resp.list[i].key_uid,
                    brand_title: resp.list[i].brand_title,
                    withdraw_currency_title: resp.list[i].withdraw_currency_title,
                    amount_in_withdraw_currency_without_comission: resp.list[i].amount_in_withdraw_currency_without_comission,
                    amount_in_withdraw_currency_with_comission: resp.list[i].amount_in_withdraw_currency_with_comission,
                    player_currency_title: resp.list[i].player_currency_title,
                    amount_in_player_currency_with_comission: resp.list[i].amount_in_player_currency_with_comission,
                    amount_in_player_currency_without_comission: resp.list[i].amount_in_player_currency_without_comission,
                    exchange_rate_withdraw_to_player: resp.list[i].exchange_rate_flow_to_player,
                    player_withdraw_nocomission_limit_before: resp.list[i].player_withdraw_nocomission_limit_before,
                    player_balance_before: resp.list[i].player_balance_before,
                    player_balance_after: resp.list[i].player_balance_after,
                    description: resp.list[i].description,
                    date_added: moment(resp.list[i].date_added_uts_ms).utc(false),
                    date_changed: moment(resp.list[i].date_changed_uts_ms).utc(false),
                    withdraw_basis_title: resp.list[i].withdraw_basis_title,
                    withdraw_type_code: resp.list[i].withdraw_type_code,
                    withdraw_type_title: resp.list[i].withdraw_type_title,
                    player_id: resp.list[i].player_id,
                    player_login: resp.list[i].player_login,
                    player_email: resp.list[i].player_email,
                    player_is_locked: resp.list[i].player_is_locked,
                    partner_id: resp.list[i].partner_id,
                    partner_login: resp.list[i].partner_login,
                    partner_email: resp.list[i].partner_email,
                    withdraw_state_code: resp.list[i].withdraw_state_code,
                    withdraw_state_title: resp.list[i].withdraw_state_title,
                    is_pending: resp.list[i].is_pending,
                    withdraw_data: resp.list[i].withdraw_data,
                    withdraw_req: resp.list[i].withdraw_req,
                    withdraw_resp: resp.list[i].withdraw_resp,
                    money_balance: resp.list[i].money_balance,
                    points_balance: resp.list[i].points_balance,
                    is_active_bonus: resp.list[i].is_active_bonus,
                    bonus_balance: resp.list[i].bonus_balance,
                    is_suspicious: resp.list[i].is_suspicious
                });
            }
            _this.Update();
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    FinanceWithdrawRequestsListCtl.prototype.RemoveItem = function (key) {
        var i_idx = -1;
        for (var i = 0; i < this.DATA.data.length; i++) {
            if (this.DATA.data[i].key === key) {
                i_idx = i;
            }
        }
        var rest = this.DATA.data.slice(i_idx + 1);
        this.DATA.data.length = i_idx;
        return this.DATA.data.push.apply(this.DATA.data, rest);
    };
    FinanceWithdrawRequestsListCtl.prototype.DoConfirmWithdrawal = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoNewWithdrawCommit.exec({ data: { usr_player_moneyflow_id: key } }, function (resp) {
                if (!resp.force_withdrawal) {
                    _tmp.is_pending = true;
                }
                else {
                    _this.RemoveItem(_tmp.key);
                }
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FinanceWithdrawRequestsListCtl.prototype.DoRejectWithdrawal = function (key, onDone) {
        var _this = this;
        var _tmp = this.getById(key);
        if (_tmp) {
            webAApi_1.DoNewWithdrawReject.exec({ data: { usr_player_moneyflow_id: key } }, function (resp) {
                _this.Update();
                if (onDone) {
                    onDone();
                }
            }, function (err) {
                _this._errDialog.ShowApiError(err);
            });
        }
    };
    FinanceWithdrawRequestsListCtl.prototype.doSendMessage = function (data, onDone) {
        var _this = this;
        webAApi_1.DoAddUserPlayerMessage.exec({
            usr_player_id: data.usr_player_id,
            title: data.title,
            message: data.message
        }, function (resp) {
            if (onDone) {
                onDone();
            }
        }, function (err) {
            _this._errDialog.ShowApiError(err);
        });
    };
    return FinanceWithdrawRequestsListCtl;
}(BaseController_1.BaseController));
exports.FinanceWithdrawRequestsListCtl = FinanceWithdrawRequestsListCtl;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/finance_withdraw_requests_list/ctl/FinanceWithdrawRequestsListCtl.ts
// module id = 966
// module chunks = 0